// In Vite, use import.meta.env instead of process.env
// Vite exposes env variables prefixed with VITE_ or we can use define in vite.config.ts
export const VITE_ENV = import.meta.env.VITE_ENV || import.meta.env.MODE;
export const SITE_URL = import.meta.env.VITE_SITE_URL || "";
export const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;
export const SOCKET_URI = import.meta.env.VITE_SOCKET_URI;
export const ADMIN_ID = import.meta.env.VITE_ADMIN_ID || "";
export const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID;
export const PRINT_URI = import.meta.env.VITE_PRINT_URI;
export const PRINT_API_KEY = import.meta.env.VITE_PRINT_API_KEY;
export const PRINT_API_ADMIN_KEY = import.meta.env.VITE_PRINT_ADMIN_API_KEY;
export const NOTIFY_API_URL = import.meta.env.VITE_NOTIFY_API_URL;
